export default {
  "signStr": "1001",
  "tab": {
    "my": "मेरा",
    "home": "घर",
    "record": "अभिलेख",
    "grab": "झपटना",
    "financing": "फाइनेंसिंग",
    "make_money": "झपटना"
  },
  "newTab": {
    "home": "घर",
    "money": "धन",
    "shop": "दुकान",
    "order": "आदेश",
    "my": "मेरा",
    "team": "टीम"
  },
  "common": {
    "unrealized": "कर रहा है",
    "all": "सभी",
    "distributionTip": "0 वितरण 0 वितरण शुल्क",
    "easeBack": "वापस करना",
    "addCarSuccess": "सफलतापूर्वक खरीदारी में शामिल हों",
    "deleteConfirm": "क्या आप चयनित आइटम को हटाना सुनिश्चित करते हैं?"
  },
  My: {
    "download": "ऐप डाउनलोड करें",
    "personal": "व्यक्तिगत जानकारी",
    "preOrde": "पूर्व-आदेश अभिलेख",
    "account": "खाता विवरण",
    "recharge": "टॉप-अप रिकॉर्ड",
    "withdrawal": "निकासी",
    "invite": "मित्रों को आमंत्रित करें",
    "announcement": "घोषणा",
    "service": "सेवा",
    "team": "टीम रिपोर्ट",
    "quit": "छोड़ना",
    "logoutEvent": "बाहर निकलने की पुष्टि करें?",
    "language": "भाषा सेटिंग",
    "languageButton": {
      "english": "अंग्रेज़ी",
      "indonesian": "इन्डोनेशियाई"
    },
    "logout": "लॉग आउट",
    "MemberInformation": {
      "SilverMember": "रजत सदस्य",
      "Invitation": "आमंत्रण संकेत",
      "balance": "खाते में शेष",
      "Recharge": "लबालब भरना",
      "Withdraw": "निकालना",
      "forzenAll": "जमे हुए धन"
    },
    "PersonalInformation": {
      "Page": {
        "title": "मेरी जानकारी",
        "Avatar": "अवतार",
        "Nickname": "उपनाम",
        "PhoneNumber": "फ़ोन नंबर",
        "BankAccounts": "मेरा बटुआ पता",
        "Password": "पासवर्ड",
        "TransactionPassword": "लेन -देन पासवर्ड",
        "ReceivingAddress": "प्राप्त पता"
      },
      "portrait": {
        "SetAvatar": "अवतार सेट करना",
        "button": "अब सेट करना"
      },
      "Name": {
        "ModifyNickname": "उपनाम को संशोधित करें",
        "title": "अपने उपनाम को संशोधित करें",
        "name": "उपनाम",
        "Modify": "संशोधित",
        "Please": "कृपया एक निकनाम दर्ज करें"
      },
      "BankAccounts": {
        "BankAccounts": "बैंक कार्ड",
        "YourInformation": "आपकी जानकारी",
        "RealName": "वास्तविक नाम",
        "RealNameNote": "कृपया अपना असली नाम निर्धारित करें",
        "PhoneNo": "फ़ोन नंबर",
        "PhoneNoNote": "कृपया फोन नंबर सेट करें",
        "YourBankCard": "आपके बैंक कार्ड की जानकारी",
        "BankAccount": "बैंक खाता",
        "BankAccountNote": "कृपया बैंक खाता सेट करें",
        "BankName": "बैंक का नाम",
        "BankNameData": {
          "option1": "खाता बैंक चुनें",
          "option2": "बैंक सेंट्रल एशिया",
          "option3": "बैंक नेगारा इंडोनेशिया",
          "option4": "बैंक रकीट इंडोनेशिया",
          "option5": "मंदिरी बैंक"
        },
        "BankBranch": "बैंक शाखा",
        "BankBranchNote": "कृपया बैंक शाखा सेट करें",
        "MoreInformation": "अधिक जानकारी",
        "WhatsApp": "WhatsApp",
        "WhatsAppNote": "कृपया व्हाट्सएप नंबर सेट करें",
        "Text": "अनुस्मारक: हैलो, अपने अधिकारों की गारंटी देने के लिए, कृपया सही कार्ड नंबर और बैंक जानकारी को बांधें।यदि खाता गलत भरने के कारण प्राप्त नहीं किया जा सकता है, तो यह प्लेटफ़ॉर्म कोई जिम्मेदारी नहीं लेता है!",
        "Settings": "समायोजन"
      },
      "Password": {
        "title": "लॉगिन पासवर्ड को संशोधित करें",
        "PleaseEnter": "कृपया अपना नया पासवर्ड दर्ज करें",
        "phone": "फ़ोन",
        "NewPhone": "कृपया अपना सेल फोन नंबर दर्ज करें",
        "verificationCode": "कोड वेरिफिकासी",
        "verificationCodeNote": "कृपया एक सत्यापन कोड दर्ज करें",
        "oldPassword": "पुराना पासवर्ड",
        "oldPasswordNote": "अपना पुराना पासवर्ड दर्ज करें",
        "ConfirmPassword": "नया पासवर्ड",
        "ConfirmPasswordNote": "अपना नया पासवर्ड दर्ज करें",
        "Text": "कृपया पासवर्ड याद रखें, यदि आप पासवर्ड भूल जाते हैं, तो कृपया ग्राहक सेवा से संपर्क करें।",
        "ButtonCode": "सत्यापन कोड प्राप्त करें",
        "Button": "संशोधित करने के लिए ठीक है",
        "verifyPhone": "कृपया अपना सेल फोन नंबर दर्ज करें",
        "PhoneNew": "कृपया पुष्टि करें कि आपने समाप्त कर दिया है"
      },
      "Site": {
        "title": "पता संशोधन प्राप्त करना",
        "ReceivingIdentity": "पहचान की जानकारी प्राप्त करना",
        "ReceivingAddress": "पता जानकारी प्राप्त करना",
        "DetailedAddress": "विस्तृत पता",
        "DetailedAddressNote": "कृपया विस्तृत पता दर्ज करें",
        "Set": "सामान्य पते के रूप में सेट करें",
        "Button": "पुष्टि करना",
        "hint": "कृपया पुष्टि करें कि आपने समाप्त कर दिया है"
      },
      "AccountData": {
        "title": "लेनदेन का विवरण",
        "To": "को",
        "search": "खोज",
        "Cancel": "रद्द करना",
        "Semua": "सभी प्रकार",
        "Penarikan": "निकासी नोट",
        "IsiUlang": "टॉप-अप म्यूटेशन"
      },
      "RechargeRecord": {
        "title": "टॉप-अप रिकॉर्ड",
        "Recharge": "टॉप-अप ऑफ़लाइन",
        "Online": "ऑनलाइन टॉप-अप",
        "Amount": "टॉप-अप राशि:",
        "Order": "क्रम संख्या:",
        "Status": "टॉप-अप स्थिति:"
      },
      "WithdrawalRecord": {
        "title": "निकासी अभिलेख",
        "withdrawal": "बैंक कार्ड निकासी"
      },
      "InviteFriends": {
        "Invite": "लिंक ： आमंत्रित करें कॉपी पर क्लिक करें",
        "InvitationCode": "आमंत्रण संकेत:",
        "Click": "लिंक की प्रतिलिपि करें"
      },
      "Announcement": {
        "title": "घोषणा",
        "System": "तंत्र घोषणा"
      },
      "TheTeamReport": {
        "title": "टीम रिपोर्ट",
        "To": "को",
        "search": "खोज",
        "Cancel": "रद्द करना",
        "balance": "टीम राशि",
        "turnover": "टीम टॉप-अप",
        "recharge": "टीम आदेश लाभ",
        "withdrawal": "टीम वापसी",
        "Commission": "टीम आदेश लाभ",
        "charge": "लोगों की कुल संख्या",
        "people": "टॉप-अप वाले उपयोगकर्ताओं की संख्या",
        "members": "नए उपयोगकर्ताओं की संख्या",
        "NewPeople": "नया उपयोगकर्ता टॉप-अप",
        "Active": "नए उपयोगकर्ताओं की संख्या",
        "Level1": "स्तर 1",
        "Level2": "लेवल 2",
        "Level3": "स्तर 3"
      }
    },
    "PlatformIntroduction": {
      "PlatformIntroduction": "प्लेटफ़ॉर्म परिचय",
      "Two": "यह मंच लाखों व्यापारियों से बना एक गठबंधन है।इसका सेवा सिद्धांत है: प्लेटफ़ॉर्म ट्रेडर्स ट्रेडिंग वॉल्यूम बढ़ाते हैं, और प्लेटफ़ॉर्म के सदस्य ऑर्डर प्राप्त करके लाभ आय अर्जित करते हैं।",
      "Three": "तृतीय-पक्ष इंटेलिजेंट क्लाउड होस्ट ऑर्डर मैचिंग प्लेटफॉर्म को नियंत्रित करता है।प्लेटफ़ॉर्म अन्य ऑनलाइन शॉपिंग प्लेटफ़ॉर्म व्यापारियों के साथ मिलकर इंटेलिजेंट क्लाउड सिस्टम के माध्यम से प्लेटफ़ॉर्म उपयोगकर्ताओं के साथ व्यावसायिक आदेशों से मेल खाने के लिए सहयोग करता है, ताकि मुख्य प्लेटफॉर्म पर लेनदेन की मात्रा और विक्रेता की प्रतिष्ठा बढ़ाई जा सके।खरीद आदेश की वितरण विधि में सुधार किया जाता है।ऑर्डर स्वचालित रूप से रिमोट इंटेलिजेंट क्लाउड सर्वर द्वारा भेजा जाता है।प्लेटफ़ॉर्म उपयोगकर्ताओं को केवल स्मार्ट क्लाउड होस्ट में प्रवेश करने के लिए मंच पर सीधे पूर्ण रिसीवर पता, टेलीफोन नंबर और कुछ खरीदारी की जानकारी प्रदान करने की आवश्यकता है।",
      "Four": "विक्रेताओं को प्रभावी ढंग से आदेशों की सफलता दर में सुधार करने और झूठे आदेशों की जाँच करने वाले विक्रेताओं के जोखिम से बचने के लिए, प्लेटफ़ॉर्म आपके वर्तमान ऑपरेटिंग आईपी और उपकरण प्रकार के अनुसार दिन के ऑर्डर मिलान का अनुकूलन करेगा।इसलिए, ऑर्डर मिलान को बुद्धिमान क्लाउड कंप्यूटिंग एल्गोरिथ्म द्वारा महसूस किया जाना चाहिए।कृपया धैर्यपूर्वक प्रतीक्षा करें।प्लेटफ़ॉर्म उपयोगकर्ता मंच में शामिल होने के लिए नए लोगों को बढ़ावा देकर स्वचालित रूप से प्लेटफ़ॉर्म एजेंट बन जाएंगे, और उन्हें अतिरिक्त लाभ मिल सकता है।",
      "Five": "आपको बस इंटरनेट पर सर्फ करने के लिए अपने खाली समय का उपयोग करने की आवश्यकता है, और आप हर दिन आसानी से समृद्ध लाभ कमा सकते हैं।आपके द्वारा क्लिक करने और सफलतापूर्वक आदेश भेजने के बाद, प्रिंसिपल और लाभ वापस कर दिया जाएगा।"
    },
    "RuleDescription": {
      "RuleDescription": "नियम विवरण",
      "One": "1. सदस्यों को प्राप्तकर्ता के पते को भरना होगा और ऑर्डर लेने से पहले व्यक्तिगत जानकारी बढ़नी चाहिए।विभिन्न कार्यों के अनुसार अलग -अलग प्लेटफ़ॉर्म सदस्यों के कमीशन।सिस्टम द्वारा उत्पन्न आदेशों की संख्या आपके खाता शेष के 30% -70% पर आधारित है।",
      "Two": "2. क्योंकि माल के आदेश को लागू करने के लिए एक निश्चित समय की आवश्यकता होती है, आदेश मान्य होने के बाद ऑर्डर केवल विक्रेता के साथ प्राप्त किया जा सकता है, इसलिए प्लेटफ़ॉर्म कमीशन और त्रिपक्षीय बैंक को पूरा करना और सदस्य टी + 1. सिस्टम का उपयोग करते हैं, अर्थात्: आज वापस लेने के लिए और धन को अगले दिन 23:59 से पहले प्राप्त किया जाएगा।यदि आदेश निर्दिष्ट समय के बाद आवेदन करने में विफल रहता है, तो प्लेटफ़ॉर्म पैसे में भुगतान करेगा, खाता पूरा करेगा और निर्दिष्ट समय के भीतर भुगतान जारी करेगा।",
      "Three": "3. उपयुक्त हॉल की स्थिति और चांदी के सदस्यों के कमीशन का अनुपात: सभी चांदी के सदस्य प्रति दिन 10 ऑर्डर ले सकते हैं, और आदेश के लिए आयोग माल की संख्या का 0.30% है।",
      "Four": "सोने के सदस्य: सोने के सदस्यों को खोलने के लिए, आपको इस हॉल में प्रवेश करने के लिए 3 लोगों को आमंत्रित करने की आवश्यकता है।आप प्रति दिन 35 ऑर्डर ले सकते हैं, और ऑर्डर के लिए कमीशन माल की संख्या का 0.35% है।",
      "Five": "प्लैटिनम के सदस्य: प्लैटिनम सदस्यों को खोलने के लिए, आपको इस हॉल में प्रवेश करने के लिए 10 लोगों को आमंत्रित करने की आवश्यकता है। आप प्रति दिन 40 ऑर्डर प्राप्त कर सकते हैं, और आदेश के लिए आयोग माल की संख्या का 0.40% है।",
      "Six": "प्लैटिनम के सदस्य: प्लैटिनम सदस्यों को खोलने के लिए, आपको इस हॉल में प्रवेश करने के लिए 10 लोगों को आमंत्रित करने की आवश्यकता है। आप प्रति दिन 40 ऑर्डर प्राप्त कर सकते हैं, और आदेश के लिए आयोग माल की संख्या का 0.40% है।",
      "Seven": "डायमंड के सदस्य: हीरे के सदस्यों को खोलने के लिए, आपको इस हॉल में प्रवेश करने के लिए 30 लोगों को आमंत्रित करने की आवश्यकता है।आप प्रति दिन 45 ऑर्डर प्राप्त कर सकते हैं, और इन आदेशों के लिए कमीशन माल की संख्या का 0.45% है।",
      "Eight": "4. भरने से पहले कृपया प्लेटफ़ॉर्म डिपॉजिट कार्ड नंबर की जाँच करें और प्लेटफ़ॉर्म खाता संख्या को अनियमित रूप से बदल देगा।मंच व्यक्तिगत परिचालन त्रुटियों के कारण संपत्ति के नुकसान के लिए जिम्मेदार नहीं होगा।",
      "Nine": "नोट: कृपया मंच से बैंक कार्ड की जानकारी देखें कि क्या यह आपके आर्थिक नुकसान से बचने के लिए प्रत्येक हस्तांतरण के लिए यह मंच है।",
      "Ten": "5. विक्रेता और मंच के बीच लाभ की रक्षा के लिए, इसलिए प्रत्येक आईपी, बैंक कार्ड नंबर और मोबाइल नंबर केवल एक खाते पर लागू हो सकते हैं।सभी मुख्य ई-नियागा प्लेटफार्मों में जोखिम नियंत्रण मशीनें हैं, यदि एक ही क्षेत्र में कई उपयोगकर्ता और एक ही आईपी जो एक ही स्टोर पर खरीदारी करते हैं, तो दुकान विस्फोटक उत्पादों को समाप्त कर देगा और विक्रेताओं की विश्वसनीयता और बिक्री को प्रभावित करेगा।",
      "Eleven": "यदि कोई व्यक्ति कई खातों के लिए अनुरोध प्रस्तुत करता है, तो उल्लंघनकर्ता स्थायी रूप से खातों को फ्रीज करेंगे और 30 दिनों के लिए शेष राशि को फ्रीज करेंगे।जब आपको जमे हुए बैलेंस (अवधि के अंत का अंत) को वापस लेने की आवश्यकता होती है, तो कृपया वापस लेने के लिए खाते को सक्रिय करने के लिए हमारी ऑनलाइन ग्राहक सेवा से संपर्क करें।",
      "OneData": {
        "One": "कार्य परिचय:",
        "Two": "आयोग टैरिफ कार्य के प्रकार",
        "Three": "लाजदा 0.30%",
        "Four": "BUKALAPAK 0.35%",
        "Five": "शोपी 0.40%",
        "Six": "टोकोपेडिया 0.45%"
      },
      "TwoData": {
        "One": "सदस्यता स्तर विवरण:",
        "Two": "चांदी के सदस्यों की सदस्यता का प्रकार",
        "Three": "50,000,000 की निकासी सीमा",
        "Four": "आदेशों की संख्या 30/दिन",
        "Five": "कमीशन स्तर 0.30%",
        "Six": "आमंत्रित करना-"
      },
      "FourData": {
        "One": "प्लैटिनम सदस्यों की सदस्यता का प्रकार",
        "Two": "50,000,000 की निकासी सीमा",
        "Three": "आदेशों की संख्या 40/दिन",
        "Four": "कमीशन स्तर 0.40%",
        "Five": "10 को आमंत्रित करें"
      },
      "FiveData": {
        "One": "हीरे के सदस्यों के सदस्यों के प्रकार",
        "Two": "50,000,000 की निकासी सीमा",
        "Three": "आदेशों की संख्या 45/दिन",
        "Four": "कमीशन स्तर 0.45%",
        "Five": "30 को आमंत्रित करें"
      },
      "Twelve": "*विभिन्न स्तरों को विषम संख्या और कमीशन अनुपात मिल सकते हैं।सदस्यता स्तर जितना अधिक होगा, उतनी ही विषम संख्याएं आप ले सकते हैं।आदेश जितना अधिक होगा, आयोग उतना ही अधिक होगा।"
    },
    "AgentCooperation": {
      "AgentCooperation": "एजेंट सहयोग",
      "One": "प्रॉक्सी के लिए तीसरा स्तर का मानक लॉन्च",
      "Two": "सदस्य नए सदस्यों की सिफारिश करके एक प्रॉक्सी मंच हो सकता है जो अतिरिक्त पुरस्कार प्राप्त करने के लिए शामिल होते हैं।",
      "Three": "हर दिन 9% बोनस कमीशन प्राप्त करने के लिए पहले -level उपयोगकर्ता पुरस्कारों को बढ़ावा दें। दूसरे स्तर के उपयोगकर्ता पुरस्कार के लिए हर दिन हर दिन एक 6% बोनस कमीशन है, जो हर दिन 3% बोनस कमीशन है।",
      "Four": "उदहारण के लिए:",
      "Five": "आपके पहले -लेवल प्रॉक्सी ने 10 लोगों को सदस्यों के रूप में शामिल होने के लिए आमंत्रित किया है, दूसरे स्तर के प्रॉक्सी ने 20 लोगों को सदस्यों के रूप में शामिल होने के लिए आमंत्रित किया है और तीसरे स्तर के प्रॉक्सी ने 40 लोगों को सदस्यों के रूप में शामिल होने के लिए आमंत्रित किया है।एक दिन के लिए प्रति व्यक्ति आय 200,000 inr है, इसलिए बस उस दैनिक आय की कल्पना करें जो आपको मिलेगी।",
      "Six": "पहला स्तर: 200,000 x 10 x 9% = 180,000 INR",
      "Seven": "दूसरा स्तर: 200,000 x 20 x 6% = 240,000 INR",
      "Eight": "तीसरा स्तर: 200,000 x 40 x 3% = 240,000 INR",
      "Nine": "पहला स्तर + दूसरा स्तर + तीसरा स्तर = 660,000 INR",
      "Ten": "मान लीजिए कि आप सदस्यों को पंजीकृत करने के लिए आमंत्रित करते हैं, एक आमंत्रित बी, और बी आमंत्रित सी,",
      "Eleven": "तब सदस्य A आपकी टीम का पहला स्तर का उपयोगकर्ता है, B आपका दूसरा स्तर का उपयोगकर्ता है, और C आपका तीसरा स्तर का उपयोगकर्ता है।",
      "Twelve": "पुरस्कारों की संख्या = आदेश आयोग एक x 9% + आदेश आयोग B x 6% + आयोग आदेश C x 3%।",
      "Thirteen": "*अनुस्मारक: सभी एजेंटों के लिए आयोग पुरस्कार जो इस मंच द्वारा जारी किए गए ऑफ़लाइन सदस्य हैं, और सभी एजेंटों और ऑफ़लाइन सदस्यों के आयोग को प्रभावित नहीं करेंगे!"
    },
    "CommonProblem": {
      "CommonProblem": "आम समस्या",
      "One": "प्रश्न: व्यवसायों को आभासी आदेशों की आवश्यकता क्यों है?",
      "Two": "मुख्य ई-कॉमर्स प्लेटफ़ॉर्म नियमों के अनुसार, अधिक लोग उत्पाद खरीदते हैं, अधिक लोकप्रिय उत्पाद, और अधिक अवसरों को ई-कॉमर्स प्लेटफॉर्म द्वारा प्रोत्साहित और प्रदर्शित किया जाएगा।ई-कॉमर्स व्यवसाय भयंकर है।उत्पाद जोखिम बढ़ाने के लिए, व्यापारियों को कमोडिटी लेनदेन की मात्रा बढ़ाने की आवश्यकता होती है, इसलिए वे प्लेटफ़ॉर्म पर आभासी आदेशों का उत्पादन करना चुनते हैं।",
      "Three": "प्रश्न: आप ऑर्डर लेने की प्रक्रिया को कैसे पूरा करते हैं?",
      "Four": "E-Niaga चैनल का चयन करें, स्वचालित रूप से एक ऑर्डर लेने के लिए क्लिक करें, सिस्टम ऑर्डर प्राप्त करने के लिए उत्पाद को समझदारी से मेल खाता है।प्लेटफ़ॉर्म ऑनलाइन शॉपिंग का अनुकरण करने के लिए ई-कॉमर्स प्लेटफॉर्म पर ऑर्डर भेजने के लिए आपकी वास्तविक व्यक्तिगत जानकारी, शिपिंग पता और नेटवर्क आईपी का उपयोग करता है।हालांकि, व्यापारी वास्तव में अपना माल नहीं भेजते हैं।आदेश को सफलतापूर्वक भेजने के बाद, मुख्य और आदेश आयोग को आपके खाते में वापस कर दिया जाएगा।",
      "Five": "प्रश्न: आदेश प्राप्त करने से पहले मुझे रिचार्ज करने की आवश्यकता क्यों है?",
      "Six": "ऑर्डर की प्रामाणिकता सुनिश्चित करने के लिए, प्रत्येक सिम्युलेटेड ऑर्डर प्लेटफॉर्म को ई-नागा वेबसाइट को वास्तविक भुगतान की आवश्यकता होती है।प्लेटफार्मों और व्यापारियों के हितों की रक्षा के लिए, ऑर्डर भेजने पर आपका खाता शेष कम हो जाएगा, और ऑर्डर पूरा होने के बाद इसे वापस कर दिया जाएगा।",
      "Seven": "प्रश्न: आदेशों की संख्या बढ़ाने और कमीशन कैसे बढ़ाएं?",
      "Eight": "दोस्तों को पंजीकृत करने के लिए आमंत्रित करके, उच्च स्तर, प्रति दिन कुल आदेशों की संख्या, और अधिक आयोग अनुपात; सिस्टम स्वचालित रूप से खाता शेष के 30% और 70% के बीच आदेशों की संख्या से मेल खाता है, इसलिए, इसलिए, खाता शेष राशि, प्रत्येक आदेश की उच्च संख्या और उच्चतर आयोग जितना अधिक होगा।",
      "Nine": "प्रश्न: पंजीकरण करने के लिए दोस्तों को कैसे आमंत्रित करें?",
      "Ten": "\"इनवेट फ्रेंड्स\" पर क्लिक करें, शेयरिंग लिंक या क्यूआर कोड कॉपी करें, और इसे सामाजिक सॉफ्टवेयर के माध्यम से दोस्तों, सहपाठियों, सहकर्मियों और अपने परिवार को भेजें।आपको इस प्लेटफ़ॉर्म पर पंजीकरण के लिए निमंत्रण कोड भरना होगा, और अन्य पक्ष पंजीकरण के बाद आपकी टीम के सदस्य बन जाएंगे।",
      "Eleven": "प्रश्न: नकदी कैसे निकालें?",
      "Twelve": "आप न्यूनतम आदेश मात्रा को पूरा करने के बाद नकद निकासी जमा कर सकते हैं।यदि न्यूनतम आदेश मात्रा आवश्यकताओं को पूरा नहीं किया जाता है, तो आवश्यकताओं को पूरा करने तक बस जारी रखें।वापसी के अनुमोदित होने के बाद, प्लेटफ़ॉर्म आपके बाउंड बैंक खाते में धन जमा करेगा, और सही रसीद का समय आपके बैंक पर निर्भर करता है।"
    },
    "MemberUpgrade": {
      "MemberUpgrade": "सदस्य उन्नयन",
      "Member": "सदस्य स्तर ：",
      "Orders": "हर दिन उपलब्ध आदेश:",
      "Commission": "लाभ वृद्धि",
      "DedicatedOne": "समर्पित ग्राहक सेवा",
      "DedicatedTwo": "समर्पित ग्राहक सेवा",
      "Swipe": "अधिक देखने के लिए बाएं और दाएं स्वाइप करें",
      "One": {
        "Silver": "रजत सदस्य",
        "Need": "0 लोगों को आमंत्रित करने की जरूरत है",
        "Withdrawal": "निकासी सीमा: 50.000.000",
        "quantity": "आदेश मात्रा: 10/दिन",
        "rate": "लाभ दर: 0.30%",
        "fee": "वापसी शुल्क: 2.00%",
        "Activated": "सक्रिय"
      },
      "Two": {
        "Silver": "गोल्ड मेंबर",
        "Need": "3 लोगों को आमंत्रित करने की जरूरत है",
        "People": "3 लोग अभी भी कम हैं",
        "Withdrawal": "निकासी सीमा: 50.000.000",
        "quantity": "आदेश मात्रा: 35/दिन",
        "rate": "लाभ दर: 0.35%",
        "fee": "वापसी शुल्क: 2.00%",
        "Activated": "दैनिक टॉप-अप राशि: 1.000.000",
        "Invite": "अब आमंत्रित करें"
      },
      "Three": {
        "Silver": "प्लैटिनम सदस्य",
        "Need": "10 लोगों को आमंत्रित करने की जरूरत है",
        "People": "10 लोग अभी भी कम हैं",
        "Withdrawal": "निकासी सीमा: 50.000.000",
        "quantity": "आदेश मात्रा: 40/दिन",
        "rate": "लाभ दर: 0.40%",
        "fee": "वापसी शुल्क: 2.00%",
        "Activated": "दैनिक टॉप-अप राशि: 1.500.000",
        "Invite": "अब आमंत्रित करें"
      },
      "Four": {
        "Silver": "हीत सदस्य",
        "Need": "30 लोगों को आमंत्रित करने की जरूरत है",
        "People": "30 लोग अभी भी कम हैं",
        "Withdrawal": "निकासी सीमा: 50.000.000",
        "quantity": "आदेश मात्रा: 45/दिन",
        "rate": "लाभ दर: 0.45%",
        "fee": "वापसी शुल्क: 2.00%",
        "Activated": "दैनिक टॉप-अप राशि: 2.000.000",
        "Invite": "अब आमंत्रित करें"
      }
    },
    "PhoneNew": "कृपया पुष्टि करें कि आपने समाप्त कर दिया है",
    "Toast": {
      "One": "सफलतापूर्वक सहेजें",
      "Two": "असफल"
    },
    "Button": {
      "One": "रद्द करना",
      "Two": "पुष्टि करना"
    }
  },
  "Financing": {
    "time": "समय",
    "day": "दिन",
    "Fina": "फंड",
    "assets": "कुल संपत्ति",
    "amount": "वित्तीय राशि",
    "revenue": "कुल मुनाफा",
    "earnings": "कल की कमाई",
    "Balance": "बैलेंस स्थानांतरित करना",
    "RP": " ",
    "Estimated": "अनुमानित आय",
    "Income": "आय मानक",
    "TransferOut": "बाहर स्थानांतरण",
    "ransferIn": "में स्थानांतरण",
    "SukuBung": "सुकू बुंगा",
    "Transfer": "विफल में स्थानांतरण",
    "Pleaseint": "कृपया राशि दर्ज करें",
    "Successful": "सफल अंतरण",
    "Please": "कृपया राशि में ट्रांसफर इनपुट करें",
    "RansferInSU": {
      "FinancialAcc": "वित्तीय अभिगम अभिलेख",
      "Acc": "अभिगम लॉग"
    },
    "ServiceSu": {
      "Please": "कृपया दर्ज करें...",
      "send": "भेजो",
      "Online": "ऑनलाइन सेवा",
      "Service": "सेवा",
      "Customer": "पेलयान पेलंगगन",
      "Ifyou": "यदि आप समस्याओं का सामना करते हैं और मदद की आवश्यकता है, तो कृपया ऑनलाइन Cunstomer Servic से संपर्क करें",
      "Layanana8": "ग्राहक सेवा केंद्र No.8 (व्हाट्सएप)",
      "Layanana9": "ग्राहक सेवा केंद्र नंबर 9 (व्हाट्सएप)",
      "Dedicated": "समर्पित cunstomer सेवा",
      "Telegram8": "लेनाना पेलंगगन नंबर 8 (टेलीग्राम)",
      "Telegram008": "Tegervam008",
      "Telegram9": "लेनाना पेलंगगन नंबर 9 (टेलीग्राम)",
      "Telegram009": "Telegram009"
    }
  },
  Home: {
    "HallofFame": "हॉल ऑफ फेम",
    "Member": "सदस्य NWES",
    "Mission": "मिशन हॉल",
    "Learnde": "लर्नड",
    "Hello": "नमस्ते",
    "Let": "देिए मॉल ने धन का रास्ता खोल दिया",
    "total": "मेरी कुल संपत्ति",
    "Withdraw": "निकालना",
    "Recharge": "लबालब भरना",
    "RP": " ",
    "earningsRp": "कल की कमाई",
    "incomeRp": "संचयी आवरण",
    "rarningsRp": "आज की कमाई",
    "Service": "सेवा",
    "Invite": "आमंत्रित करना",
    "Lazada": "Lazada",
    "Bukalapak": "बुकलपक",
    "Shopee": "Shopee",
    "Tokopedia": "Tokopedia",
    "silver": "चैनल सदस्यों के लिए चैनल",
    "gold": "स्वर्ण सदस्य चैनल",
    "platinum": "प्लैटिनम सदस्यों के लिए चैनल",
    "diamond": "हीरे के सदस्यों के लिए चैनल",
    "Agent": "एजेंट आदेश लाभ",
    "Order": "आदेश लाभ",
    "RechargeSu": {
      "Recharge": "लबालब भरना",
      "Catatan": "कैटटन खुसस:",
      "Next": "अगला",
      "RechargeAm": "टॉप-अप राशि",
      "Enter": "टॉप-अप राशि दर्ज करें",
      "Quick": "त्वरित चयन",
      "nameP": "कृपया अपना असली नाम दर्ज करें",
      "name": "नाम",
      "Pleaseamount": "कृपया राशि दर्ज करें",
      "Pleaseint": "कृपया राशि दर्ज करें",
      "Pleasename": "कृपया अपना नाम दर्ज करें"
    },
    "WithdrawSu": {
      "Withdraw": "निकालना",
      "Withdrawal": "निकाली गयी राशि",
      "WithdrawalRe": "निकासी दर",
      "Input": "इनपुट निकासी राशि",
      "Balance": "संतुलन",
      "WithdrawAll": "सभी को वापस लेना",
      "Mobile": "मोबाइल फोन नंबर",
      "Bank": "बैंक कार्ड नंबर",
      "Owned": "स्वामित्व बैंक",
      "Account": "खाता नाम",
      "Transaction": "लेन -देन पासवर्ड",
      "Withdrawim": "तुरंत वापस लेना",
      "Pleaseamount": "कृपया राशि दर्ज करें",
      "Pleasephone": "कृपया अपना फोन नंबर दर्ज करें",
      "Pleasecard": "कृपया अपना बैंक कार्ड नंबर दर्ज करें",
      "Pleasebank": "कृपया अपना बैंक नाम दर्ज करें",
      "Pleasename": "कृपया अपना नाम दर्ज करें",
      "Pleasepassword": "कृपया लेन -देन पासवर्ड दर्ज करें",
      "Pleaseint": "कृपया राशि दर्ज करें",
      "PasswordError": "गलत पासवर्ड",
      "Successful": "पहले से ही वापसी के लिए आवेदन किया",
      "Insufficient": "अपर्याप्त वापसी संतुलन",
      "Unbound": "बैंक कार्ड बाध्य नहीं किया गया है",
      "Binding": "अपने बैंक कार्ड को बाध्य करें",
      "idCard": "पहचान पत्र क्रमांक"
    }
  },
  Login: {
    "indexTitle": "में प्रवेश",
    "remenber": "पासवर्ड याद रखें",
    "versions": "V.86",
    "masuk": "दाखिल करना",
    "name": "ऐप डाउनलोड",
    "forgot": "भूल गया",
    "registrasi": "पंजीकरण",
    "loginButton": "दाखिल करना",
    "nameInput": "मोबाइल नंबर दर्ज करें",
    "pwdInput": "अपना कूटशब्द भरें",
    "notLoginHint": "दाखिल करना",
    "goLoginText": "पुष्टि करना",
    "Forgot": {
      "title": "पासवर्ड पुनःप्राप्त करें",
      "registerTitle": "पंजीकरण करवाना",
      "phone": "अपना फोन नंबर डालें",
      "code": "सत्यापन कोड दर्ज करें",
      "area": "कृपया क्षेत्र कोड दर्ज करें",
      "sendCode": "कोड भेजो",
      "password": "पासवर्ड",
      "againPassword": "पासवर्ड की पुष्टि कीजिये",
      "confirm": "जमा करना",
      "goBack": "एक खाता था, अब साइन इन करें",
      "register": "दफ़्टार"
    },
    "Daftar": {
      "username": "उपयोगकर्ता नाम",
      "title": "पंजीकरण करवाना",
      "area": "कृपया क्षेत्र कोड दर्ज करें",
      "phone": "मोबाइल नंबर दर्ज करें",
      "code": "सत्यापन कोड दर्ज करें",
      "userName": "उपनाम",
      "password": "पासवर्ड",
      "againPassword": "पासवर्ड की पुष्टि कीजिये",
      "payPassword": "भुगतान पासवर्ड",
      "referrer": "आमंत्रण कोड"
    }
  },
  Cart: {
    "title": "आदेश दुकान",
    "explain": "विवरण",
    "grade": {
      "SliverMember": "टूटकर अलग हो जाना\nसदस्य",
      "GoldMember": "सोना\nसदस्य",
      "PlatinumMember": "प्लैटिनम\nसदस्य",
      "DiamondMember": "डायमंड\nसदस्य"
    },
    "info": {
      "allMoney": "मेरा कुल\n एक सेट",
      "dayAllOrder": "आज का दि\n कुल आदेश",
      "dayTrustMoney": "आज का दि\n आयोग",
      "yesterdayMoney": "कल का\n आय"
    },
    "text": {
      "rebateAndPrincipal": "वापस करना\n राजधानी\n और\n लाभ",
      "residue": "बचा हुआ",
      "one": "आदेश",
      "rebate": "वापसी लाभ",
      "buyBtn": "अभी खरीदें",
      "toGet": "अकन मेंडापत",
      "orderSuccess": "सफल आदेश देना",
      "orderGetMoney": "भुगतान सफल",
      "orderWaiting": "इंतज़ार में",
      "orderOver": "पूर्ण"
    },
    "state": {
      "all": "सभी\nप्रक्रिया पर\nचुकाया गया\nजमा हुआ\nपूर्ण"
    },
    "zzInfo": {
      "buyIng": "क्रय",
      "buySucceedFindDT": "खरीद के बाद स्थिति दृश्य पर क्लिक करें\n सफल है",
      "ok": "ठीक",
      "buyFailed": "खरीद विफल रही",
      "notLevel": "आपका वीआईपी स्तर अपर्याप्त है",
      "buyJurisdiction1": "अगर एक गोल्ड सदस्यता ऑर्डे खरीदना चाहते हैं",
      "buyJurisdiction2": "यदि एक प्लेटिनम सदस्यता आदेश खरीदना चाहते हैं",
      "buyJurisdiction3": "यदि हीरा सदस्यता आदेश खरीदना चाहते हैं",
      "meet": "निम्नलिखित शर्तों में से एक को पूरा किया जाना चाहिए",
      "invite1": "एक साथ पैसा बनाने के लिए 3 दोस्तों को आमंत्रित करें",
      "invite4": "एक साथ पैसा बनाने के लिए 10 दोस्तों को आमंत्रित करें",
      "invite3": "एक साथ पैसा बनाने के लिए 30 दोस्तों को आमंत्रित करें",
      "buySendMoney": "2. सदस्यता हीरे खरीदने के लिए RS2000 खर्च करें",
      "invite2": "मित्रों को आमंत्रित करें",
      "buy": "अभी खरीदें",
      "myMoney": "आपका खाता शेष",
      "under": "नीचे",
      "notSendMoney": "खिचड़ी भाषा लेनदेन",
      "goTopUp": "कृपया टॉप-अप करें",
      "know": "मुझे पता है",
      "account": "समझौता"
    },
    "hint": {
      "p1": "1. विभिन्न सदस्यता स्तरों में अलग -अलग खरीद आदेश हैं",
      "p2": "2. आपका सदस्यता स्तर जितना अधिक होगा, ऑर्डर लाभ राशि उतनी ही अधिक है जिसे खरीदा जा सकता है",
      "p3": "3. खरीदे गए आदेशों के लिए, आप किसी भी समय ऑर्डर की स्थिति की निगरानी कर सकते हैं"
    }
  },
  Hint: {
    "SendCodeSuccess": "सत्यापन कोड सफलतापूर्वक भेजा जाता है!",
    "closed": "बंद किया हुआ",
    "notTime": "कोई समय नहीं चुना गया",
    "notTimeFailed": "समय चयन विफल",
    "success": "सफल",
    "failed": "असफल",
    "phoneNot": "कोई एचपी/नहीं अकुन तिदाक बिसा कोसॉन्ग",
    "pwdInconformity": "पासवर्ड समान नहीं है",
    "notMoney": "मनी अपर्याप्त",
    "notEvent": "फ़ीचर कैंट का उपयोग अभी तक",
    "notInput": "अधूरा डेटा इनपुट",
    "loading": "लोड हो रहा है",
    "notMore": "अब और नहीं",
    "notPhone": "खाता मौजूद नहीं है",
    "yesPhone": "खाता पहले से मौजूद है",
    "levelNot": "लेवलनोट",
    "serverMaintenance": "कृपया धैर्य रखें, खेल रखरखाव में है",
    "invite": "मित्रों को आमंत्रित करें\n पैसा बनाने के लिए\n साथ में",
    "goodsNumNo": "काफी मात्रा में",
    "haveBuy": "खरीदा",
    "depositBtnText1": "डाइटरिमा",
    "depositBtnText2": "उपलब्ध",
    "depositBtnText3": "पाना",
    "commissionMoney": "वापसी लाभ:",
    "bill": "बिल",
    "billRecordTitle": "बिलिंग अभिलेख",
    "balance": "संतुलन",
    "reference": "पेस्ट इनविटेशन कोड",
    "updateText": "कृपया नवीनतम संस्करण पर अपडेट करें"
  },
  newAdd: {
    "all": "सभी",
    "Completed": "पुरा होना",
    "unfinished": "अधूरा",
    "GetCodeBtn": "सत्यापन कोड प्राप्त करें",
    "copySuccess": "सफलता की नकल!",
    "copyError": "विफलता की नकल करें!",
    "noLoginUserName": "कृपया लॉगिन करें",
    "Withdraw": "निकालना",
    "Recharge": "लबालब भरना",
    "commission": "खरीदारी कार्ट आयोग",
    "single": "अकेला",
    "missionHall": "मिशन हॉल",
    "videoTutorial": "वीडियो ट्यूटोरियल",
    "helpCenter": "सहायता केंद्र",
    "inviteFriends": "मित्रों को आमंत्रित करें",
    "play": "अब खेलते हैं",
    "help1Title": "मुडो के साथ कमीशन कैसे करें",
    "help1Context": "ई-कॉमर्स व्यवसाय मालिकों को स्टोर की बिक्री बढ़ाने की आवश्यकता है, इसलिए हमें केवल ई-कॉमर्स स्टोर की आवश्यकताओं को पूरा करने और मुडो सॉफ्टवेयर पर ऑर्डर पूरा करने की आवश्यकता है।मालिक हमें लाभ देगा।प्रत्येक उपयोगकर्ता प्रति दिन 10 ऑर्डर कार्य प्राप्त कर सकता है।आप एक दिन में 10% से 30% लाभ कमा सकते हैं।",
    "help2Title": "मिशन की संख्या कैसे बढ़ाएं",
    "help2Context": "क्योंकि बहुत सारे अंशकालिक कर्मचारी हैं, कंपनी यह बताती है कि सभी ऑनलाइन अंशकालिक कर्मचारी केवल व्हाट्सएप का उपयोग करते हैं और संपर्क प्राप्त करते हैं।",
    "help3Title": "मिशन को कैसे पूरा करें",
    "help3Context": "यह प्रमुख व्यापारियों को बिक्री बढ़ाने और लेनदेन की संख्या के अनुसार आपको पुरस्कृत करने में मदद करना है।हर सफल आदेश के लिए, आप कमीशन अर्जित करते हैं और विक्रेता प्रतिष्ठा अर्जित करते हैं।",
    "referralLink": "सिफ़ारिश के लिंक:",
    "copy": "कॉपी",
    "paste": "पेस्ट करें",
    "blance": "संतुलन",
    "todayOrder": "आज का आदेश",
    "provided": "डेटा द्वारा प्रदान किया जाता है",
    "Transaction": "लेन-देन",
    "Frozen": "असमानता",
    "Done": "पूर्ण",
    "Cancel": "रद्द करना",
    "ExpectedReturn": "अपेक्षित आय:",
    "ImmediatePayment": "अविलंब भुगतान",
    "AvailableNum": "वहाँ अभी भी",
    "OrderImmediately": "तुरंत आदेश दें",
    "MakeMoneyEveryDay": "हर दिन पैसा कमाएं",
    "TodayRecord": "आज का रिकॉर्ड",
    "AllocatCommissions": "आयोगों का आवंटन",
    "FrozenAmount": "बकाया राशि",
    "TaskMatch": "टास्क ऑर्डर रैंडमनेस",
    "AvailableBalance": "उपलब्ध शेष राशि",
    "WaitDispatch": "प्रेषण की प्रतीक्षा में, कृपया स्टोर मैनेजर से संपर्क करें!",
    "OrderDescription": "आदेश विवरण",
    "CouldMatch": "कार्य को यादृच्छिक रूप से सिस्टम द्वारा मिलान किया जाता है",
    "OrderPerDay": "अकेला।",
    "DescriptionRate": "ऑर्डर प्लेसमेंट लाभ समान रूप से है",
    "DescriptionPeriod": "आदेश राशि का।",
    "Description3": "सिस्टम एलबीएस तकनीक पर आधारित है और स्वचालित रूप से क्लाउड के माध्यम से उत्पादों से मेल खाता है।",
    "Description4": "प्लेटफ़ॉर्म की देखरेख को रोकने के लिए, यदि आदेश की पुष्टि नहीं की जाती है और 20 मिनट के भीतर प्रस्तुत की जाती है, तो सिस्टम ऑर्डर राशि को फ्रीज कर देगा।",
    "Note": "टिप्पणी:",
    "DescriptionNote": "कृपया प्रासंगिक सामग्री को ध्यान से पढ़ें: P2P ब्लॉकचेन सिस्टम उपयोगकर्ता के लिए आदेश से मेल खाने के बाद, नोट: प्लेटफ़ॉर्म मर्चेंट बैकग्राउंड को ऑर्डर की जानकारी सबमिट करेगा।यदि उपयोगकर्ता 60 मिनट के भीतर एक आदेश जमा नहीं करता है, तो ऑर्डर राशि सिस्टम द्वारा जमे हुए हो जाएगी।पर्यवेक्षण प्रणाली से बचने के लिए, कृपया पुष्टि करने के बाद स्वीकार करें, प्राप्त करने के बाद सभी कार्यों को रद्द या प्रतिस्थापित नहीं किया जा सकता है!यदि अन्य समस्याएं हैं जिनसे निपटा जाना चाहिए, तो कृपया ओवरटाइम फ्रीजिंग से बचने के लिए समय पर स्टॉप ऑर्डर पर क्लिक करें, आपके समर्थन के लिए धन्यवाद",
    "OrderNum": "क्रम संख्या:",
    "TotalOrderPrice": "कुल आदेश मूल्य",
    "SubmitNow": "अभी जमा करे",
    "Record": "अभिलेख",
    "MemberAccount": "सदस्य लेखा",
    "AccountPlaceholder": "कृपया अपना सदस्य खाता दर्ज करें",
    "RechargeAmount": "टॉप-अप राशि",
    "RechargeAmountPlaceholder": "कृपया टॉप-अप की राशि दर्ज करें",
    "SelectRechargeMethod": "टॉप-अप विधि का चयन करें",
    "NotBeenSentOrder": "आदेश नहीं भेजा गया है, कृपया आदेश भेजने के लिए कर्मचारियों से संपर्क करें!",
    "TodayOrderOver": "ऑनलाइन ग्राहक सेवा से संपर्क करें",
    "NotLogin": "आप लॉग इन नहीं हैं, कृपया लॉग इन करें और फिर से प्रयास करें!",
    "HaveNoteMethod": "सीमित उद्घाटन, कृपया बिक्री टीम से संपर्क करें!",
    "Login": "लॉग इन करें",
    "AccountRecord": "आय और व्यय",
    "RealName": "वास्तविक नाम",
    "IFSCCODE": "पिक्स सीपीएफ",
    "BankName": "पिक्स खाता",
    "ChainType": "चेन प्रकार",
    "BankNum": "पिक्स का प्रकार",
    "Mobile": "गतिमान",
    "MobileNum": "मोबाइल नंबर",
    "Email": "ईमेल",
    "EmailRequired": "ईमेल की जरूरत है",
    "AddBankCardNote": "वापसी की जानकारी सही ढंग से भरी होनी चाहिए",
    "AddWalletNote": "नोट: वॉलेट पता महत्वपूर्ण जानकारी है, कृपया इसे ध्यान से भरें!",
    "Submit": "जमा करना",
    "AddBankCardTitle": "पिक्स जोड़ें",
    "AddWalletTitle": "वॉलेट पता जोड़ें",
    "BankCard": "बैंक कार्ड",
    "WalletInfo": "बटुआ जानकारी",
    "Name": "नाम",
    "CardNum": "कार्ड नंबर (एसी आईडी)",
    "WalletAddress": "पता",
    "Reading": "पढ़ रहा है ...",
    "AllBalance": "समग्र संतुलन",
    "EnterWithdrawalAmount": "कृपया निकासी राशि दर्ज करें",
    "AllOut": "सब बाहर जाएं",
    "AskNow": "पुष्टि करना",
    "EnterPwdPlaceholder": "कृपया एक पासवर्ड इनपुट करें",
    "NotHaveCard": "आपने वापसी की जानकारी नहीं दी है, क्या आप सेटिंग्स पर जाना चाहते हैं?",
    "NotHaveWallet": "आपने अपना वॉलेट पता सेट नहीं किया है, क्या आप सेटिंग पर जाना चाहते हैं?",
    "GetBankInfoFail": "बैंक जानकारी प्राप्त करने में विफल रहा",
    "EnterValidPayPwd": "कृपया एक वैध भुगतान पासवर्ड दर्ज करें!",
    "Balance": "संतुलन",
    "Total": "कुल",
    "total": "कुल",
    "records": "अभिलेख",
    "DisplayPerPage": "प्रत्येक पृष्ठ प्रदर्शित करता है",
    "NullNum": "",
    "pages": "पेज।",
    "toAudit": "लेखापरीक्षा करना",
    "succeed": "सफल",
    "RechargeRecordTitle": "टॉप-अप-रिकॉर्ड",
    "rests": "टिकी हुई है",
    "Arrive": "आना",
    "Income": "आय",
    "Expenditure": "व्यय",
    "forzenCommission": "लावारिस लाभ",
    "companyIntro": "कंपनी प्रोफाइल",
    "companyTitle": "टाटा मॉल टाटा ग्रुप का हिस्सा है",
    "warmTitle": "चेतावनी",
    "companyText": "टाटा समूह भारत का सबसे बड़ा व्यापार समूह है, जिसकी स्थापना 1868 में हुई थी और इसका मुख्यालय मुंबई, भारत में है।व्यावसायिक संचालन में सात व्यावसायिक क्षेत्र शामिल हैं: संचार और सूचना प्रौद्योगिकी, इंजीनियरिंग, सामग्री, सेवाएं, ऊर्जा, उपभोक्ता उत्पाद और रासायनिक उत्पाद।भारत में तेजी से बढ़ते व्यापार समूह के रूप में, टाटा समूह में 200 से अधिक सहायक कंपनियां हैं, 6 महाद्वीपों पर 80 से अधिक देशों में संचालन, और 85 देशों में उत्पादों और सेवाओं का निर्यात।2020-2021 वित्तीय वर्ष के लिए टाटा समूह का कुल राजस्व $ 100.09 बिलियन है, जिसमें से 58% विदेशी संचालन से आता है।दुनिया भर के समूह के कर्मचारियों की संख्या लगभग 450,000 है।153 वर्षों से, भारत में टाटा नाम का व्यापक रूप से अच्छे मूल्यों और व्यावसायिक नैतिकता के पालन के लिए व्यापक रूप से सम्मान किया गया है।फोर्ब्स द्वारा दुनिया में 11 वीं सबसे सम्मानित कंपनी के रूप में रैंक किया गया।",
    "depositAddress": "जमा पता",
    "rechargeSteps": "टॉप-अप चरण",
    "completePayment": "पूर्ण भुगतान",
    "rechargeNow": "टॉप-अप नाउ",
    "rechargeCancel": "भुगतान रद्द करें",
    "bankName": "बैंक का नाम",
    "payee": "द पाई",
    "cardNum": "बैंक कार्ड नंबर",
    "reviewing": "समीक्षा के अंतर्गत",
    "remittance": "सफल",
    "notThrough": "असफल",
    "OrderID": "आदेश कामतत्व",
    "Amount": "मात्रा",
    "toCutScreen": "यदि छवि उपलब्ध नहीं है तो कृपया एक स्क्रीनशॉट लें!",
    "cardTabBank": "किनारा",
    "cardTabUSDT": "USDT",
    "name": "नाम",
    "chainType": "चेन प्रकार",
    "newNavTitle": "आदेश प्रस्तुत",
    "shopMoney": "माल की मात्रा",
    "actualMoney": "वास्तविक सबमिशन",
    "commitBtnText": "आदेश देना",
    "commitHint": "अधूरा इनपुट"
  },
  "mine": {
    "servier": "सर्वर",
    "integral": "अभिन्न",
    "balance": "भुनाना",
    "record": "अभिलेख",
    "wtdAmt": "अंक भुनाएं",
    "avaBlc": "विनिमय मात्रा",
    "allWtd": "सभी",
    "close": "रद्द करना",
    "commit": "पुष्टि करना",
    "wtdHint": "कृपया सही निकासी राशि दर्ज करें"
  },
  "add": {
    "Commission": "आज अनसुलझी राशि",
    "Yesterday": "कल",
    "Cumulative": "संचयी",
    "Today": "आज",
    "TeamNum": " कुल टीम का आकार",
    "TeamMoney": " कुल टीम लाभ",
    "Personalcenteraccountchangerecord": "खाता परिवर्तन अभिलेख",
    "lockedbalance": "बकाया राशि",
    "Cumulativeinvitation": "संचयी निमंत्रण",
    "Validinvitation": "मान्य निमंत्रण",
    "Accumulatedrebate": "संचित छूट"
  },
  "home.btn.wallet": "फंड",
  "home.btn.recharge": "जमा करना",
  "home.btn.withdraw": "निकालना",
  "home.btn.invite": "आमंत्रित करना",
  "home.btn.message": "संदेश",
  "page.grab": "झपटना",
  "orderCommission": "आदेश लाभ",
  "commission": "लाभ",
  "todayIncome": "आज आय",
  "personalEarnings": "व्यक्तिगत कमाई",
  "completedOrders": "पूर्ण आदेश",
  "lockedOrders": "बंद आदेश",
  "unfinishOrder": "अधूरा आदेश",
  "frozonAmount": "असंबद्ध निधियां",
  "currentBalance": "वर्तमान शेष",
  "page.mine": "खाता विवरण",
  "mine.invitationCode": "आमंत्रण संकेत",
  "mine.serverCenter": "सर्वर केंद्र",
  "mine.tools.total": "कुल",
  "mine.tools.financial": "फंड",
  "mine.tools.details": "विवरण",
  "mine.tools.freeze": "संतुलन",
  "mine.serviceTools.personal": "निजी",
  "mine.serviceTools.teamReport": "टीम रिपोर्ट",
  "mine.serviceTools.invite": "पारिवारिक लेखा",
  "mine.serviceTools.message": "संदेश",
  "mine.serviceTools.aboutUs": "हमारे बारे में",
  "mine.serviceTools.security": "सुरक्षा",
  "mine.serviceTools.address": "पता",
  "mine.serviceTools.inviteTask": "कार्य आमंत्रित करें",
  "page.team": "टीम",
  "page.aboutus": "हमारे बारे में",
  "page.financial": "फंड",
  "page.financialRecord": "वित्तीय अभिलेख",
  "hint.InternetErr": "नेटवर्क त्रुटि, कृपया बाद में पुनः प्रयास करें!",
  "totalDeposit": "कुल जमा",
  "totalRevenue": "कुल मुनाफा",
  "btn.transferInto": "स्थानांतरित करना",
  "btn.transferOut": "बाहर स्थानांतरण",
  "page.transferInto": "स्थानांतरित करना",
  "page.transferOut": "बाहर स्थानांतरण",
  "balanceTransfer": "बैलेंस स्थानांतरित करना",
  "availableBalance": "उपलब्ध शेष राशि",
  "depositRate": "जमा दर",
  "days": "दिन",
  "hint.success": "सफलता",
  "hint.fail": "असफल",
  "status.into": "स्थानांतरित करना",
  "status.out": "बाहर स्थानांतरण",
  "label.amount": "मात्रा",
  "label.time": "समय",
  "Button": {
    "cancle": "रद्द करना",
    "confirm": "पुष्टि करना"
  },
  "dialog.title.inputPaypass": "भुगतान पासवर्ड दर्ज करें",
  "dialog.nopaypass": "भुगतान पासवर्ड सेट नहीं किया गया है, सेटिंग पर जाने के लिए ठीक क्लिक करें!",
  "mine.serviceTools.lan": "भाषा",
  "checkLans": "स्विच भाषा",
  "mine.tools.commission": "लाभ",
  "page.commissionRecord": "लाभ",
  "noticeList.all": "सभी",
  "noticeList.unread": "अपठित ग",
  "successWithdrawof": "की सफल वापसी",
  "home.title.notice": "सूचना",
  "home.title.patener": "उसके साथ साझेदारी में",
  "login.rememberPassword": "पासवर्ड याद रखें",
  page: {
    "cart": "कार्ट",
    "order": "आदेश",
    "financing": "फाइनेंसिंग",
    "goods": "चीज़ें",
    "levelUpgrade": "स्तर उन्नयन",
    "PlatformIntroduction": "प्लेटफ़ॉर्म परिचय",
    "RuleDescription": "नियम विवरण",
    "AgentCooperation": "एजेंट सहयोग",
    "CommonProblem": "आम समस्या",
    "MemberUpgrade": "सदस्य उन्नयन",
    "login": "लॉग इन करें",
    "forgot": "भूल गया",
    "registrasi": "रजिस्ट्रासी",
    "record": "अभिलेख",
    "Recharge": "जमा करना",
    "inviteFriends": "मित्रों को आमंत्रित करें",
    "Withdraw": "निकालना",
    "Service": "सेवा",
    "DialoguePage": "संवाद पृष्ठ",
    "user": "निजी",
    "RansferIn": "रैंसरिन",
    "PersonalCenter": "व्यक्तिगत केंद्र",
    "Portrait": "चित्र",
    "Name": "नाम",
    "Account": "खाता",
    "Password": "पासवर्ड",
    "PaymentCode": "अदायगी",
    "Site": "साइट",
    "AccountData": "खाता",
    "RechargeRecord": "टॉप-अप रिकॉर्ड",
    "WithdrawalRecord": "निकासी अभिलेख",
    "InviteFriends": "मित्रों को आमंत्रित करें",
    "Announcement": "घोषणा",
    "TheTeamReport": "टीम की रिपोर्ट",
    "BillRecord": "बिल अभिलेख",
    "BankCardAdd": "बैंक कार्ड जोड़ें",
    "NewRecharge": "लबालब भरना",
    "RechargeList": "टॉप-अप सूची",
    "newWithdraw": "निकालना",
    "withdrawList": "सूची वापस लेना",
    "SettingPayPwd": "तय करना",
    "MakeMoney": "पैसा बनाएं",
    "team": "टीम",
    "qrPay": "QRCODE-PAY",
    "bankPay": "बैंक-भुगतान",
    "aboutus": "हमारे बारे में",
    "financial": "फंड",
    "financialRecord": "वित्तीय अभिलेख",
    "TransferInto": "स्थानांतरित करना",
    "TransferOut": "बाहर स्थानांतरण",
    "CommissionRecord": "लाभ",
    "Security": "सुरक्षा",
    "Address": "पता",
    "Message": "संदेश",
    "InviteTask": "इनविटेटस्क",
    "Notice": "सूचना",
    "modifyPaymentPassword": "भुगतान पासवर्ड को संशोधित करें"
  },
  "copyLink": "लिंक की प्रतिलिपि करें",
  "teamReport": {
    "title": "टीम रिपोर्ट",
    "subTitle": "अधीनस्थ टीम अवलोकन",
    "taskTitle": "आदेश को पूरा करने और पूरा करने के लिए {संख्या} लोगों को आमंत्रित करें",
    "bonus": "बक्शीश",
    "Unfinished": "अधूरा",
    "Getted": "गेबाड़ा हुआ"
  },
  "copy": "प्रतिलिपि",
  "address": {
    "name": "नाम",
    "inputPlaceholder": "कृपया भर लीजिए",
    "phone": "फ़ोन",
    "areaPlaceholer": "वितरण पता संक्रमण",
    "submit": "बचाना"
  },
  "password.old": "पुराना पासवर्ड",
  "password.old.placeholder": "अपना पुराना पासवर्ड दर्ज करें",
  "password.confirmPassword": "पासवर्ड की पुष्टि कीजिये",
  "password.confirmPassword.placeholder": "फिर से नया पासवर्ड दर्ज करें",
  "hint.passwordDiff": "दो पासवर्ड मेल नहीं खाता हैं",
  "loginType": {
    "phone": "फ़ोन",
    "email": "ईमेल"
  },
  "Login.Daftar.email": "ईमेल",
  "Login.emailInput": "अपना ईमेल दर्ज करें",
  "My.PersonalInformation.Password.email": "ईमेल",
  "My.PersonalInformation.Password.NewEmail": "कृपया अपना सेल ईमेल दर्ज करें",
  "mine.serviceTools.certify": "सत्यापन",
  "Certification": {
    "type": {
      "id": "पहचान (आरजी)",
      "driver": "ड्राइवर का लाइसेंस",
      "passport": "पासपोर्ट"
    },
    "name": "नाम",
    "license": "लाइसेंस संख्या",
    "upload": "दस्तावेज़ अनुलग्नक",
    "submit": "जमा करना",
    "incompleteInformation": "कृपया जानकारी भरें और पुनः प्रयास करें!",
    "submitSuccess": "प्रमाणन जानकारी प्रस्तुत की गई है, कृपया समीक्षा की प्रतीक्षा करें!",
    "photo": "आईडी फोटो",
    "review": "समीक्षा के अंतर्गत",
    "verified": "सत्यापित"
  },
  "upload": {
    "uploading": "अपलोड करना ...",
    "failed": "अपलोड विफल"
  },
  "login.forgetPassword": "अपना पासवर्ड भूल गए, कृपया ग्राहक सेवा से संपर्क करें!",
  "newAdd.BankNum.placeholder": "उदाहरण: 09xxxxxxxxxx",
  "page.certification": "पहचान सत्यापन",
  "newAdd.page": "पृष्ठ",
  "newAdd.record": "अभिलेख",
  "emailFormatError": "कृपया सही ईमेल पता दर्ज करें!",
  "urlParsePlaceholder": "कृपया पेस्ट पहचान दर्ज करें",
  "btn.Identify": "तुरंत पहचानें",
  "produceStatus.confirming": "पुष्टि की",
  "produceStatus.paying": "भुगतान किया जाना है",
  "produceStatus.paid": "चुकाया गया",
  "produceStatus.done": "पूर्ण",
  "produceStatus.cancle": "वापसी की गई है",
  "order.old": "उच्च आय आदेश",
  "order.new": "नियमित आदेश",
  "welfareDialogTitle": "लाभ युक्तियाँ",
  "viGrabDesces": {
    "1": "प्रत्येक आदेश को एक भाग्यशाली आदेश के रूप में चुना जा सकता है और आयोग को {दर}%तक बढ़ाया जाएगा।आगे के आउटरीच असाइनमेंट के लिए आवेदन करने के लिए कृपया अपने आउटरीच मेंटर से संपर्क करें",
    "2": "शोपी सेलर्स को वर्चुअल ऑर्डर निर्माण, दृश्यता बढ़ाने और कमीशन अर्जित करने में मदद करें",
    "3": "ऑर्डर प्राप्त करने के बाद जितनी जल्दी हो सके अपने प्रचार ट्यूटर से संपर्क करें, ऑर्डर डेटा जमा करें और कार्य पूरा करें",
    "4": "कार्यों की संख्या सीमित है, कृपया आदेश स्वीकार करते समय प्रशिक्षक के प्रचार सुझावों पर ध्यान दें",
    "5": "कार्य पूरा करने के बाद 5-10 मिनट के भीतर धनवापसी राशि जारी की जाएगी।यदि आपके कोई प्रश्न हैं, तो कृपया एक विशेषज्ञ या ऑनलाइन ग्राहक सेवा से परामर्श करें।",
    "6": "Shopee द्वारा सौंपे गए कार्यों को पूरा करें, VIP स्तर में सुधार करें, और Fackbook कार्यों के लिए उच्च आयोग प्राप्त करें",
    "7": "अतिरिक्त कमीशन प्राप्त करने के लिए संचित रूप से नामित शोपी कार्यों को पूरा करें।विशिष्ट पुरस्कारों के लिए, कृपया पदोन्नति विशेषज्ञ या ऑनलाइन ग्राहक सेवा से परामर्श करें"
  },
  "expectedEarningsTitle": "प्रत्याशित आय",
  "rechargeDesc": {
    "nav": "रिचार्ज विवरण",
    "p1": "अब हमारे पास एक ही समय में बहुत सारे कर्मचारी हैं।",
    "p2": "एक विक्रेता पर्याप्त खाते प्रदान नहीं कर सकता है",
    "p3": "इसलिए हम अपने विक्रेता खाते को एक और खाली में पोस्ट करते हैं",
    "p4": "जब आपको कार्य पूरा करने की आवश्यकता होती है तो आप अपने भुगतान चैनल को पंजीकृत करने के लिए बिक्री समर्थन से संपर्क कर सकते हैं"
  },
  "chat": {
    "list": {
      "nav": "संदेश",
      "hours": "{h} घंटे",
      "minutes": "{m} मिनट",
      "ago": "{time} पहले",
      "image": "छवि"
    },
    "room": {
      "msgPlaceholder": "एक संदेश दर्ज करें ...",
      "send": "भेजना",
      "sender": "प्रेषक",
      "sendTime": "समय भेजें",
      "content": "संतुष्ट"
    }
  },
  "Login.Daftar.selectCurrency": "मुद्रा चुनें",
  "mine.totalBalance": "कुल शेष",
  "newBank": {
    "usdt": {
      "name": "नाम",
      "currency": "मुद्रा",
      "chainType": "चेन प्रकार",
      "depositAddress": "जमा पता",
      "submit": "जमा करना",
      "bank": "बैंक",
      "wallet": "वॉलेट",
      "bankName": "बैंक नाम",
      "bankCard": "बैंक कार्ड"
    },
    "walletList": {
      "pageTitle": "निकासी प्रबंधन",
      "name": "वॉलेट उपनाम:",
      "coinType": "मुद्रा:",
      "chainType": "श्रृंखला प्रकार:",
      "walletAddress": "पता:",
      "addDate": "तारीख:",
      "btnText": "वॉलेट पता जोड़ें",
      "deleteConfirmText": "क्या आप सुनिश्चित हैं कि आप वॉलेट पते को हटाना चाहते हैं?",
      "btnConfirm": "मिटाना",
      "btnCancle": "चकमा देना",
      "successHint": "सफल"
    },
    "withdrawNum": "निकासी की संख्या",
    "AllOut": "सभी",
    "balance": "समग्र संतुलन",
    "handlingFee": "संचालन शुल्क",
    "actualAmount": "वास्तविक राशि"
  },
  "hashPlaceholder": "कृपया हैश दर्ज करें",
  "recharge.status.error": "अमेज़ॅन वर्चुअल ऑर्डर क्रिएशन फेल हो गया, कृपया सही हैश मान और आइटम राशि सबमिट करें",
  "recharge.actualAmount": "वास्तविक लेखा",
  "login.userAgreement": "उपयोगकर्ता का समझौता",
  "login.title1": "साइन अप करें",
  "login.title2": "वापसी पर स्वागत है!",
  "registe.title1": "साइन अप करें",
  "registe.title2": "वापसी पर स्वागत है!",
  "mine.credit": "श्रेय",
  "page.checkin": "चेक इन",
  "checkin.submit": "चेक इन",
  "checkin.success": "सफलतापूर्वक साइन इन करें",
  "checkin.fail": "भाग लेना विफल हुआ",
  "todayChecked": "आपने साइन इन किया है, कृपया ऑपरेशन को दोहराएं नहीं!",
  "submit.checked": "साइन इन किया",
  "hint.inviteBanned": "क्षमा करें, आपके खाते ने अभी तक एक पारिवारिक खाता नहीं खोला है, कृपया खोलने के लिए आवेदन करने के लिए ग्राहक सेवा या अपने संरक्षक से संपर्क करें!",
  "newTab.blindBox": "ब्लाइंड बॉक्स",
  "blindBox.submit": "लॉटरी शुरू करें",
  "blindBox.times": "एक छाती खोलने का अवसर: {__times__} बार",
  "blindBox.records.title": "मेरा विजेता रिकॉर्ड",
  "banEditBankHint": "बैंक कार्ड महत्वपूर्ण जानकारी है, यदि आपको इसे संशोधित करने की आवश्यकता है, तो कृपया ग्राहक सेवा से संपर्क करें!",
  "level.order_num": "महानतम उपलब्धि",
  "drawNum": "अंधे बक्से की संख्या",
  "recharge.good_title": "उत्पाद",
  "recharge.blindBoxIncome": "अंधा बक्से राजस्व",
  "recharge.amount": "मात्रा",
  "recharge.bonusRatio": "बोनस अनुपात",
  "submit": {
    "desc": {
      "1": "इवेंट उत्पाद को पूरा करने के बाद, आपको ब्लाइंड बॉक्स ड्रा बोनस अवसर मिलेगा, और बोनस रेंज उत्पाद मूल्य का 10-50% है।",
      "2": "एलबीएस तकनीक के आधार पर, सिस्टम स्वचालित रूप से क्लाउड के माध्यम से उत्पादों और अंधा बॉक्स लॉटरी के अवसरों से मेल खाता है।",
      "3": "प्लेटफ़ॉर्म पर्यवेक्षण को रोकने के लिए, यदि आदेश की पुष्टि नहीं की जाती है और 30 मिनट के भीतर प्रस्तुत किया जाता है, तो सिस्टम ऑर्डर राशि को फ्रीज कर देगा।",
      "sub_1": "उदाहरण के लिए, यदि आप R $ 3000 की एक ऑर्डर राशि का भुगतान करते हैं, तो ब्लाइंड बॉक्स बोनस अनुपात 10%-50%है, और वास्तविक बोनस रेंज R $ 300-1500 है, जिसका अर्थ है कि आपकी न्यूनतम वापसी R $ 3300 है और अधिकतम वापसी हैआर $ 4500।",
      "note": "कृपया प्रासंगिक सामग्री को ध्यान से पढ़ें:",
      "note_sub": "उपयोगकर्ता के लिए आदेश का मिलान करने के बाद, Shopee मर्चेंट बैकग्राउंड को ऑर्डर की जानकारी जमा करेगी।यदि उपयोगकर्ता 30 मिनट के भीतर एक आदेश जमा नहीं करता है, तो ऑर्डर राशि सिस्टम द्वारा जमे हुए हो जाएगी।सिस्टम पर्यवेक्षण से बचने के लिए, कृपया पुष्टि के बाद स्वीकार करें, सभी कार्यों को रद्द नहीं किया जा सकता है या स्वीकृति के बाद प्रतिस्थापित नहीं किया जा सकता है!यदि ऐसी अन्य समस्याएं हैं जिनसे निपटने की आवश्यकता है, तो कृपया ओवरटाइम फ्रीजिंग से बचने के लिए समय पर एक ऑर्डर देने से रोकने के लिए क्लिक करें, आपके समर्थन के लिए धन्यवाद।"
    }
  },
  "drawNine": {
    "times": "खजाना छाती खोलने का मौका",
    "submit": "ब्लाइंड बॉक्स बोनस",
    "percentHint": "100% विजेता"
  },
  "hint.nullOfDraw": "आपके पास आकर्षित करने का कोई मौका नहीं है",
  "hint.loginNotRead": "कृपया समझौते को पढ़ें और फिर से प्रयास करें!",
  "pages.editPhone": "फ़ोन नंबर संशोधन",
  "editPhone": {
    "label": "टेलीफोन नंबर",
    "placeholder": "टेलीफोन नंबर",
    "hint": "कृपया अपना फोन नंबर दर्ज करें"
  },
  "Button.submit": "जमा करना",
  "pages.editEmail": "ईमेल को बांधें",
  "users.email": "ईमेल",
  "users.userphone": "टेलीफ़ोन",
  "users.username": "उपयोगकर्ता नाम",
  "editEmail": {
    "label": "ईमेल",
    "placeholder": "ईमेल",
    "hintRequire": "कृपया ईमेल पता दर्ज करें",
    "hintCorrect": "कृपया अपना मान्य ईमेल दर्ज करें"
  },
  "personal.page.email": "ईमेल",
  "personal.page.phone": "टेलीफ़ोन",
  "banEditPhone": "फ़ोन नंबर महत्वपूर्ण जानकारी है, यदि आपको इसे संशोधित करने की आवश्यकता है, तो कृपया ग्राहक सेवा से संपर्क करें!",
  "banEditEmail": "ईमेल महत्वपूर्ण जानकारी है, यदि आपको इसे संशोधित करने की आवश्यकता है, तो कृपया ग्राहक सेवा से संपर्क करें!",
  "banEditUserInfo": "महत्वपूर्ण जानकारी को संशोधित नहीं किया जा सकता है, यदि आपको संशोधित करने की आवश्यकता है, तो कृपया ग्राहक सेवा से संपर्क करें!",
  "newTab.p2p": "पी 2 पी",
  "p2p": {
    "trade_method": {
      "buy": "खरीदना",
      "sell": "बेचना"
    },
    "coinList": {
      "orders": "{__} आदेश (ओं)",
      "label": {
        "amount": "मात्रा",
        "price": "कीमत",
        "limit": "आप LIMIT"
      }
    },
    "tradeDetails": {
      "trade_title_sell": "आप कितने {__} बेचना चाहते हैं?",
      "trade_title_buy": "आप कितने {__} खरीदना चाहते हैं?",
      "submit_now": "{__} अब"
    },
    "orderDetails": {
      "sellTitle": "दूसरे पक्ष से भुगतान का इंतजार",
      "buyTitle": "आपके भुगतान की प्रतीक्षा है",
      "sellHint": "दूसरे पक्ष को {__} के भीतर भुगतान पूरा करना होगा, अन्यथा ऑर्डर स्वचालित रूप से रद्द कर दिया जाएगा।",
      "buyHint": "{__} के भीतर भुगतान पूरा करें। भुगतान पूरा करने के बाद संपर्क विक्रेता पर क्लिक करें",
      "payInfo_title": "अदायगी का उल्लंघन",
      "label": {
        "totalAmount": "कुल राशि",
        "pricePerUnit": "मूल्य प्रति इकाई",
        "quantity": "मात्रा",
        "counterpaty": "प्रतिपक्षीय",
        "payMethod": "भुगतान विधि",
        "fullName": "पूरा नाम",
        "email": "ईमेल",
        "phone": "फ़ोन नंबर"
      },
      "btn_service": "विक्रेता से संपर्क कारें",
      "btn_sell": "क्रेता से संपर्क करें"
    }
  },
  "copySuccess": "सफलतापूर्वक कॉपी करें",
  "bannerText1": "{नाम} पूरा {मनी} राशि कार्य {मनी 1} कमीशन प्राप्त करने के लिए",
  "bannerText2": "बधाई {नाम} 30%कमीशन प्राप्त करने के लिए प्रीमियम कार्य का चयन करें",
  "grap": {
    "btask": "बोनस कार्य",
    "wtask": "सौंपे गए कार्य"
  },
  "new_goods": {
    "custdown": "उलटी गिनती",
    "hours": "घंटे",
    "minutes": "मिनट",
    "seconds": "सेकंड",
    "descBtn": "कार्य विवरण",
    "taskBtn": "कार्य पूरा करें"
  },
  "gift": {
    "gift_shop": "उपहार की वस्तुओं की दुकान",
    "my_gift": "मेरा तोहफ़ा",
    "away": "दे दो",
    "buy": "खरीदना",
    "overlay": {
      "inputPlaceholder": "कमरे की संख्या दर्ज करें",
      "num": "उपहारों की संख्या",
      "room": "एक कमरा नंबर उपहार",
      "no_data": "कोई उपहार नहीं"
    },
    "detailTitle": "उपहार अभिलेख",
    "num": "मात्रा",
    "room": "रूम नंबर"
  }
}